import React from 'react';

const s = {
  page: {
    width: '210mm', minHeight: '297mm', padding: '10mm 12mm',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    fontSize: '9px', color: '#1a1a1a', lineHeight: '1.4', background: '#fff',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    borderBottom: '3px solid #0f172a', paddingBottom: '10px', marginBottom: '12px',
  },
  companyName: { fontSize: '22px', fontWeight: '800', color: '#0f172a', letterSpacing: '2px' },
  companySubtitle: { fontSize: '8px', color: '#64748b', marginTop: '2px' },
  docTitle: { fontSize: '14px', fontWeight: '800', color: '#0f172a', textAlign: 'right', textTransform: 'uppercase', letterSpacing: '1px' },
  docNumber: { fontSize: '18px', fontWeight: '800', fontFamily: 'monospace', textAlign: 'right', marginTop: '2px', color: '#0f172a' },
  sectionTitle: {
    fontSize: '10px', fontWeight: '700', color: '#fff', textTransform: 'uppercase',
    letterSpacing: '1px', background: '#0f172a', padding: '4px 8px',
    marginBottom: '6px', marginTop: '14px',
  },
  infoGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '6px 14px' },
  infoGrid4: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '5px 10px' },
  infoBox: { border: '1px solid #e2e8f0', padding: '4px 6px', borderRadius: '2px' },
  lbl: { fontSize: '7px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' },
  val: { fontSize: '9px', fontWeight: '500', color: '#1e293b' },
  valBold: { fontSize: '10px', fontWeight: '700', color: '#0f172a' },
  valMono: { fontSize: '10px', fontWeight: '700', color: '#0f172a', fontFamily: 'monospace' },
  table: { width: '100%', borderCollapse: 'collapse', marginTop: '4px', fontSize: '8.5px' },
  th: {
    background: '#334155', color: '#fff', padding: '5px 6px', textAlign: 'left',
    fontSize: '7.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px',
  },
  td: { padding: '5px 6px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top' },
  tdMono: { fontFamily: 'monospace', fontWeight: '600' },
  tdR: { textAlign: 'right' },
  totalRow: { fontWeight: '700', background: '#f1f5f9' },
  badge: (color) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: '3px', fontSize: '8px', fontWeight: '700',
    background: color, color: '#fff',
  }),
  summaryBox: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: '6px', marginTop: '4px' },
  stat: { textAlign: 'center', padding: '6px 4px', border: '1.5px solid #e2e8f0', borderRadius: '4px' },
  statNum: { fontSize: '16px', fontWeight: '800' },
  statLbl: { fontSize: '7px', color: '#64748b', textTransform: 'uppercase', marginTop: '1px' },
  sigArea: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '24px',
    marginTop: '20px', paddingTop: '10px', borderTop: '2px solid #0f172a',
  },
  sigLine: { borderBottom: '1px solid #94a3b8', height: '40px', marginBottom: '4px' },
  sigLbl: { fontSize: '7px', color: '#64748b', textTransform: 'uppercase', textAlign: 'center', fontWeight: '600' },
  footer: {
    marginTop: '12px', paddingTop: '6px', borderTop: '1px solid #e2e8f0',
    display: 'flex', justifyContent: 'space-between', fontSize: '7px', color: '#94a3b8',
  },
  notesBox: {
    border: '1.5px solid #cbd5e1', borderRadius: '3px', padding: '8px',
    marginTop: '4px', minHeight: '50px', fontSize: '8px', color: '#475569',
    background: '#fafafa',
  },
  operatorNotes: {
    border: '1.5px dashed #94a3b8', borderRadius: '3px', padding: '6px',
    marginTop: '4px', minHeight: '40px', background: '#fff',
  },
};

const statusLabel = (st) => {
  const m = { open: 'Aperto', in_progress: 'In Corso', suspended: 'Sospeso', closed: 'Chiuso', completed: 'Completato', pending: 'In Attesa' };
  return m[st] || st;
};
const statusColor = (st) => {
  const m = { open: '#0ea5e9', in_progress: '#f59e0b', suspended: '#ef4444', closed: '#64748b', completed: '#10b981' };
  return m[st] || '#94a3b8';
};

const PrintableLot = ({ data }) => {
  if (!data) return null;
  const { lot, product, client, revision, work_cycles, order, order_line, progress_records, production_summary } = data;

  const progressPct = lot.quantity > 0
    ? Math.min(100, Math.round(((production_summary.good_quantity + production_summary.scrap_quantity + production_summary.rework_quantity) / lot.quantity) * 100))
    : 0;

  return (
    <div style={s.page} data-testid="printable-lot">
      <style>{'@page { size: A4 portrait; margin: 8mm; } @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }'}</style>
      {/* ===== HEADER ===== */}
      <div style={s.header}>
        <div>
          <div style={s.companyName}>INTERNAL ERP</div>
          <div style={s.companySubtitle}>Lavorazioni Meccaniche di Precisione</div>
        </div>
        <div>
          <div style={s.docTitle}>Commessa di Produzione</div>
          <div style={s.docNumber}>{lot.lot_code}</div>
          <div style={{ fontSize: '8px', textAlign: 'right', marginTop: '3px' }}>
            <span style={s.badge(statusColor(lot.status))}>{statusLabel(lot.status)}</span>
            <span style={{ marginLeft: '6px', fontSize: '8px', color: '#64748b' }}>
              Emessa il {new Date().toLocaleDateString('it-IT')}
            </span>
          </div>
        </div>
      </div>

      {/* ===== LOT + ORDER INFO ===== */}
      <div style={s.sectionTitle}>Dati Commessa</div>
      <div style={s.infoGrid}>
        <div style={s.infoBox}><div style={s.lbl}>Codice Lotto</div><div style={s.valMono}>{lot.lot_code}</div></div>
        <div style={s.infoBox}><div style={s.lbl}>N. Ordine</div><div style={s.valMono}>{order?.order_number || '-'}</div></div>
        <div style={s.infoBox}><div style={s.lbl}>Cliente</div><div style={s.valBold}>{client?.name || '-'}</div></div>
        <div style={s.infoBox}><div style={s.lbl}>Lotto Cliente</div><div style={s.valMono}>{lot?.customer_lot_snapshot || order_line?.customer_lot || '-'}</div></div>
        <div style={s.infoBox}><div style={s.lbl}>Data Apertura</div><div style={s.val}>{lot.opening_date}</div></div>
        <div style={s.infoBox}><div style={s.lbl}>Data Chiusura Prevista</div><div style={s.val}>{lot.closing_date || '-'}</div></div>
        <div style={s.infoBox}>
          <div style={s.lbl}>Consegna Richiesta</div>
          <div style={{ ...s.valBold, color: '#dc2626' }}>
            {order_line?.delivery_date_required || order?.required_delivery_date || '-'}
          </div>
        </div>
        <div style={s.infoBox}><div style={s.lbl}>Quantita Pianificata</div><div style={s.valBold}>{lot.quantity} pz</div></div>
        <div style={s.infoBox}><div style={s.lbl}>Operatore Responsabile</div><div style={s.valBold}>{lot.responsible_operator || '-'}</div></div>
        <div style={s.infoBox}><div style={s.lbl}>Macchina Assegnata</div><div style={s.valMono}>{lot.current_machine || '-'}</div></div>
      </div>

      {/* ===== PRODUCTION SUMMARY ===== */}
      <div style={s.sectionTitle}>Stato Avanzamento</div>
      <div style={s.summaryBox}>
        <div style={s.stat}>
          <div style={{ ...s.statNum, color: '#0f172a' }}>{lot.quantity}</div>
          <div style={s.statLbl}>Pianificati</div>
        </div>
        <div style={s.stat}>
          <div style={{ ...s.statNum, color: '#10b981' }}>{production_summary.good_quantity}</div>
          <div style={s.statLbl}>Buoni</div>
        </div>
        <div style={s.stat}>
          <div style={{ ...s.statNum, color: '#ef4444' }}>{production_summary.scrap_quantity}</div>
          <div style={s.statLbl}>Scarti</div>
        </div>
        <div style={s.stat}>
          <div style={{ ...s.statNum, color: '#f59e0b' }}>{production_summary.rework_quantity}</div>
          <div style={s.statLbl}>Rilavorazioni</div>
        </div>
        <div style={s.stat}>
          <div style={{ ...s.statNum, color: '#0f172a' }}>{progressPct}%</div>
          <div style={s.statLbl}>Completamento</div>
        </div>
      </div>

      {/* ===== PRODUCT DETAILS ===== */}
      <div style={s.sectionTitle}>Dettaglio Prodotto</div>
      <div style={{ border: '1.5px solid #cbd5e1', borderRadius: '4px', padding: '8px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e2e8f0', paddingBottom: '5px', marginBottom: '6px' }}>
          <div>
            <span style={{ fontSize: '14px', fontWeight: '800', fontFamily: 'monospace', color: '#0f172a' }}>
              {product?.code || '-'}
            </span>
            <span style={{ marginLeft: '10px', fontSize: '11px', fontWeight: '600', color: '#334155' }}>{product?.name || '-'}</span>
          </div>
          <div style={{ fontSize: '9px', color: '#64748b', fontWeight: '600' }}>
            Revisione: <span style={{ fontFamily: 'monospace', color: '#0f172a' }}>{revision?.revision_code || '-'}</span> ({revision?.revision_date || '-'})
          </div>
        </div>
        <div style={s.infoGrid4}>
          <div><div style={s.lbl}>Descrizione</div><div style={s.val}>{product?.description || '-'}</div></div>
          <div><div style={s.lbl}>Materiale</div><div style={s.valBold}>{product?.material || '-'}</div></div>
          <div><div style={s.lbl}>Cod. Materia Prima</div><div style={s.valMono}>{product?.raw_material_code || '-'}</div></div>
          <div><div style={s.lbl}>Trattamento Esterno</div><div style={s.val}>{product?.external_treatment || '-'}</div></div>
          <div><div style={s.lbl}>Famiglia Prodotto</div><div style={s.val}>{product?.product_family || '-'}</div></div>
          <div><div style={s.lbl}>Unita di Misura</div><div style={s.val}>{product?.unit_of_measure || '-'}</div></div>
          <div><div style={s.lbl}>Descrizione Revisione</div><div style={s.val}>{revision?.description || '-'}</div></div>
          <div><div style={s.lbl}>Note Tecniche</div><div style={s.val}>{product?.technical_notes || '-'}</div></div>
        </div>
      </div>

      {/* ===== WORK CYCLES & PHASES ===== */}
      {work_cycles && work_cycles.length > 0 && work_cycles.map((cycle) => (
        <div key={cycle.id}>
          <div style={s.sectionTitle}>
            Ciclo di Lavoro: <span style={{ fontFamily: 'monospace' }}>{cycle.code}</span> - {cycle.description}
          </div>
          {cycle.phases && cycle.phases.length > 0 && (
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={{ ...s.th, width: '6%' }}>Fase</th>
                  <th style={{ ...s.th, width: '22%' }}>Descrizione</th>
                  <th style={{ ...s.th, width: '12%' }}>Reparto</th>
                  <th style={{ ...s.th, width: '15%' }}>Macchina</th>
                  <th style={{ ...s.th, width: '8%', textAlign: 'right' }}>T. Ciclo</th>
                  <th style={{ ...s.th, width: '8%', textAlign: 'right' }}>T. Setup</th>
                  <th style={{ ...s.th, width: '12%' }}>Attrezzatura</th>
                  <th style={{ ...s.th, width: '17%' }}>Esito / Note</th>
                </tr>
              </thead>
              <tbody>
                {cycle.phases.map((phase) => {
                  const prog = progress_records.find(p => p.work_phase_id === phase.id);
                  return (
                    <tr key={phase.id} style={{ minHeight: '28px' }}>
                      <td style={{ ...s.td, ...s.tdMono, fontWeight: '700', fontSize: '10px' }}>{phase.phase_number}</td>
                      <td style={{ ...s.td, fontWeight: '600' }}>{phase.description}</td>
                      <td style={{ ...s.td, fontWeight: '600' }}>{phase.department || '-'}</td>
                      <td style={{ ...s.td, ...s.tdMono, fontSize: '8px' }}>{phase.default_machine || '-'}</td>
                      <td style={{ ...s.td, ...s.tdR, fontWeight: '600' }}>{phase.standard_time_minutes ? `${phase.standard_time_minutes} min` : '-'}</td>
                      <td style={{ ...s.td, ...s.tdR }}>{phase.setup_time_minutes ? `${phase.setup_time_minutes} min` : '-'}</td>
                      <td style={{ ...s.td, fontSize: '8px' }}>{phase.equipment || '-'}</td>
                      <td style={{ ...s.td, minHeight: '20px' }}>
                        {prog ? (
                          <span style={{ fontWeight: '600', color: '#10b981', fontSize: '8px' }}>
                            {prog.good_quantity} ok / {prog.scrap_quantity} sc
                            {prog.actual_time_minutes ? ` / ${prog.actual_time_minutes} min` : ''}
                          </span>
                        ) : (
                          <div style={{ borderBottom: '1px dotted #cbd5e1', minHeight: '14px' }} />
                        )}
                      </td>
                    </tr>
                  );
                })}
                <tr style={s.totalRow}>
                  <td style={s.td} colSpan={4}>Tempo Totale Stimato</td>
                  <td style={{ ...s.td, ...s.tdR, fontWeight: '700' }}>
                    {cycle.phases.reduce((sum, ph) => sum + (ph.standard_time_minutes || 0), 0)} min
                  </td>
                  <td style={{ ...s.td, ...s.tdR, fontWeight: '700' }}>
                    {cycle.phases.reduce((sum, ph) => sum + (ph.setup_time_minutes || 0), 0)} min
                  </td>
                  <td style={s.td} colSpan={2} />
                </tr>
              </tbody>
            </table>
          )}
        </div>
      ))}

      {/* ===== NOTES ===== */}
      <div style={s.sectionTitle}>Note Commessa</div>
      <div style={s.notesBox}>{lot.notes || ''}</div>

      {/* ===== OPERATOR NOTES AREA ===== */}
      <div style={s.sectionTitle}>Annotazioni Operatore</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        <div>
          <div style={{ ...s.lbl, marginBottom: '3px' }}>Problemi Riscontrati / Azioni Correttive</div>
          <div style={s.operatorNotes} />
        </div>
        <div>
          <div style={{ ...s.lbl, marginBottom: '3px' }}>Osservazioni / Suggerimenti</div>
          <div style={s.operatorNotes} />
        </div>
      </div>

      {/* ===== SIGNATURE AREA ===== */}
      <div style={s.sigArea}>
        <div>
          <div style={s.sigLine} />
          <div style={s.sigLbl}>Responsabile Produzione</div>
        </div>
        <div>
          <div style={s.sigLine} />
          <div style={s.sigLbl}>Responsabile Qualita</div>
        </div>
        <div>
          <div style={s.sigLine} />
          <div style={s.sigLbl}>Operatore</div>
        </div>
      </div>

      {/* ===== FOOTER ===== */}
      <div style={s.footer}>
        <span>Internal ERP - Commessa generata il {new Date().toLocaleDateString('it-IT')} alle {new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</span>
        <span>Documento riservato - Uso interno</span>
      </div>
    </div>
  );
};

export default PrintableLot;
